import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    DEACTIVATE_BUSINESS: (businessId) => ({ businessId }),
    API: {
      DEACTIVATE_BUSINESS: apiResourceActionCreator('business')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/deactivateBusiness/${payload.businessId}`, authToken, {}, actions.admin.api.deactivateBusiness);

function* deactivateBusiness(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'deactivateBusiness',
  action: actions,
  sagas: deactivateBusiness,
  reducers: {
    request: (state, action) => ({
      ...state,
      isDeactivatingUser: true,
      error: null
    }),
    success: (state, action) => {
      return ({
        ...state,
        isDeactivatingUser: false,
      })
    },
    failed: (state, action) => ({
      ...state,
      isDeactivatingUser: false,
      error: action.payload.error,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/deactivateBusiness.js